var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5646 8.31445C16.5646 8.21133 16.4802 8.12695 16.3771 8.12695L14.8303 8.13398L12.5006 10.9113L10.1732 8.13633L8.62402 8.1293C8.5209 8.1293 8.43652 8.21133 8.43652 8.3168C8.43652 8.36133 8.45293 8.40352 8.48105 8.43867L11.5303 12.0715L8.48105 15.702C8.45273 15.7363 8.43702 15.7793 8.43652 15.8238C8.43652 15.927 8.5209 16.0113 8.62402 16.0113L10.1732 16.0043L12.5006 13.227L14.8279 16.002L16.3748 16.009C16.4779 16.009 16.5623 15.927 16.5623 15.8215C16.5623 15.777 16.5459 15.7348 16.5177 15.6996L13.4732 12.0691L16.5224 8.43633C16.5506 8.40352 16.5646 8.35898 16.5646 8.31445Z",
    fill: "#FF3030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.52344C6.70156 1.52344 2 6.225 2 12.0234C2 17.8219 6.70156 22.5234 12.5 22.5234C18.2984 22.5234 23 17.8219 23 12.0234C23 6.225 18.2984 1.52344 12.5 1.52344ZM12.5 20.7422C7.68594 20.7422 3.78125 16.8375 3.78125 12.0234C3.78125 7.20938 7.68594 3.30469 12.5 3.30469C17.3141 3.30469 21.2188 7.20938 21.2188 12.0234C21.2188 16.8375 17.3141 20.7422 12.5 20.7422Z",
    fill: "#FF3030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearRedIcon);
export default __webpack_public_path__ + "static/media/clear-red-icon.3876a81f7ed6efdcbc70fe997a9b7e15.svg";
export { ForwardRef as ReactComponent };